"use client";

import { useState, useCallback, useEffect } from "react";
import { DAILY_LIMITS } from "./constants";

export interface UsageData {
  remaining: number;
  limit: number;
  used: number;
}

const DEFAULT_USAGE: UsageData = {
  remaining: DAILY_LIMITS.TRANSCRIPT,
  limit: DAILY_LIMITS.TRANSCRIPT,
  used: 0,
};

const WAITLIST_SEEN_KEY = "ytranscript_waitlist_seen";

export function useUsage() {
  const [transcriptUsage, setTranscriptUsage] = useState<UsageData>(DEFAULT_USAGE);
  const [summaryUsage, setSummaryUsage] = useState<UsageData>({ remaining: DAILY_LIMITS.SUMMARY, limit: DAILY_LIMITS.SUMMARY, used: 0 });
  const [hasSeenWaitlist, setHasSeenWaitlist] = useState(true); // Default true to prevent flash

  // Load hasSeenWaitlist from localStorage on mount
  useEffect(() => {
    const seen = localStorage.getItem(WAITLIST_SEEN_KEY);
    setHasSeenWaitlist(seen === "true");
  }, []);

  const updateTranscriptUsage = useCallback((usage: UsageData) => {
    setTranscriptUsage(usage);
  }, []);

  const updateSummaryUsage = useCallback((usage: UsageData) => {
    setSummaryUsage(usage);
  }, []);

  const totalUsed = transcriptUsage.used + summaryUsage.used;
  const shouldShowWaitlist = totalUsed >= 3 && !hasSeenWaitlist;

  const markWaitlistSeen = useCallback(() => {
    setHasSeenWaitlist(true);
    localStorage.setItem(WAITLIST_SEEN_KEY, "true");
  }, []);

  return {
    transcriptUsage,
    summaryUsage,
    updateTranscriptUsage,
    updateSummaryUsage,
    totalUsed,
    shouldShowWaitlist,
    markWaitlistSeen,
    remainingTranscripts: transcriptUsage.remaining,
    remainingSummaries: summaryUsage.remaining,
  };
}
